import { DtoObtenerDocumento } from './../dominio/DtoObtenerDocumento.';
import { Router, ActivatedRoute } from '@angular/router';
import { Route } from '@angular/router';
import { FiltroCoSeguimientoPedido } from './../dominio/FiltroCoSeguimientoPedido';

import {  LazyLoadEvent } from 'primeng/primeng';
import { NoAuthorizationInterceptor } from './../../../../util/interceptor/NoAuthorizationInterceptor';
import { MaMiscelaneosdetalleServicio } from 'src/app/erp/core/mamiscelaneosdetalle/service/mamiscelaneosdetalle.service';
import { CoDocumentoServicio } from './../../codocumento/service/codocumento.service';
import { FiltroCoDocumentoCobrar } from './../../codocumento/dominio/FiltroCoDocumentoCobrar';
import { PrincipalBaseComponent } from 'src/app/util/PrincipalBaseComponent';
import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { SelectItem, MessageService } from 'primeng/api';
import { CoSeguimientoPedidoServicio } from '../servicio/coseguimientopedidos.service';
import { WhTransaccionService } from '../../../logistica/whtransaccion/servicio/whtransaccion.servicio';
import { DtoCoDocumentoCobrar } from '../../codocumento/dominio/DtoCoDocumentoCobrar';
import { WhGuiaService } from '../../../logistica/whguia/servicio/whguia.servicio';
import { CoCobranzaServicio } from '../../cocobranza/service/cocobranza.service';
import { FiltroCoCobranza } from '../../cocobranza/dominio/FiltroCoCobranza';
import { Table } from 'primeng/table';

@Component({
    selector: 'app-pedidos-seguimiento',
    templateUrl: './pedidos-seguimiento.component.html'
})
export class PedidosSeguimiento extends PrincipalBaseComponent implements OnInit {

    lstEstados: SelectItem[] = [];
    filtro: FiltroCoSeguimientoPedido = new FiltroCoSeguimientoPedido();
    filtroCoCobranza: FiltroCoCobranza = new FiltroCoCobranza();
    seleccionados: any[] = [];
    cargando: boolean = true;
    verDocumento: Boolean = false;
    verGuia: Boolean = false;
    verLogistica: Boolean = false;
    verCobranza: Boolean = false;
    checked: boolean = true;
    noChecked: boolean = true;
    verBotonCancelar: boolean = false;
    listaDocumentos: DtoCoDocumentoCobrar[] = [];
    listarLogitica: DtoCoDocumentoCobrar[] = [];
    listarGuias: DtoCoDocumentoCobrar[] = [];
    listarCobranza: DtoCoDocumentoCobrar[] = [];

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private whTransaccionService: WhTransaccionService,
        private coCobranzaServicio: CoCobranzaServicio,
        private coSeguimientoPedido: CoSeguimientoPedidoServicio,
        private cdref: ChangeDetectorRef,
        private whGuiaService: WhGuiaService,
        noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService
    ) { super(noAuthorizationInterceptor, messageService); }
    paginacion: any = new Object();
    @ViewChild(Table,{static:false}) dt: Table;

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    ngOnInit() {
        super.ngOnInit();
        const documento = this.route.snapshot.params['documento'];
        if (documento != null) {
            this.cargando = false;
            this.filtro.numerodoc = documento;
            this.verBotonCancelar=true;
            this.cargarPaginacion({ first: 0, rows: 20 });
        }else{
            this.verBotonCancelar=false;
        }
    }

    defaultBuscar(event?: any) {
        if (event.keyCode === 13) {
            this.buscar();
        }
    }

    cargarPaginacion(event: LazyLoadEvent) {
        if (this.cargando) {
            return;
        }
        this.bloquearPagina();
        this.filtro.paginacion.listaResultado = [];
        this.filtro.paginacion.registroInicio = event.first;
        this.filtro.paginacion.cantidadRegistrosDevolver = event.rows;
        this.coSeguimientoPedido.obtenerPedidoDetalle(this.filtro)
            .then(res => {
                this.filtro.paginacion = res;
                this.desbloquearPagina();
            });
    }

    buscar() {
        if (this.filtro.numerodoc == null) {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Información', detail: 'Ingrese un Número de Documento' });
        }
        else {
            this.cargando = false;
            this.cargarPaginacion({ first: 0, rows: 20 });
            this.verDocumento = false;
        }
    }

    cargarPaginacion2() {
        this.cargando = true;
        this.bloquearPagina();
        this.coSeguimientoPedido.obtenerDocumento(this.filtro)
            .then(res => {
                this.listaDocumentos = res;
                this.desbloquearPagina();
            });
    }

    cargarPaginacionGuias() {
        this.cargando = true;
        this.bloquearPagina();
        this.whGuiaService.listarGuiasPaginacion(this.filtro)
            .then(res => {
                this.listarGuias = res;
                this.desbloquearPagina();

            });
    }

    cargarPaginacionLogistica() {
        this.cargando = true;
        this.bloquearPagina();
        this.whTransaccionService.listarDocumentosLogisticaPaginacion(this.filtro)
            .then(res => {
                this.listarLogitica = res;
                this.desbloquearPagina();
            });
    }

    cargarPaginacionCobranza() {
        this.cargando = true;
        this.bloquearPagina();
        this.coCobranzaServicio.listarDocumentosCobranza(this.filtroCoCobranza)
            .then(res => {
                this.listarCobranza = res;
                this.desbloquearPagina();
            });
    }

    buscarCobranza() {
        this.cargarPaginacionCobranza();
        this.verCobranza = true;
    }

    buscarGuia() {
        this.cargarPaginacionGuias();
        this.verGuia = true;
    }
    buscarlogistica() {
        this.cargarPaginacionLogistica();
        this.verLogistica = true;
    }

    buscarDocumento() {
        this.cargarPaginacion2();
        this.verDocumento = true;
    }


    limpiarCliente() {
        this.filtro.numerodoc = null;
    }

    cancelar() {
        this.router.navigate(['/royal/pedido-listado'], { skipLocationChange: true });
    }
}
